import { Bar, BarChart, CartesianGrid, Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

type AttendanceData = {
  name: string;
  value: number;
};

interface AttendanceChartProps {
  present: number;
  absent: number;
  halfDay: number;
}

const COLORS = ["#4CAF50", "#F44336", "#FF9800", "#2196F3"];

const AttendanceChart: React.FC<AttendanceChartProps> = ({
  present,
  absent,
  halfDay,
}) => {
  const data: AttendanceData[] = [
    { name: "Present", value: present },
    { name: "Absent", value: absent },
    { name: "Half Day", value: halfDay },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* Pie Chart */}
      <div className="h-[26rem] bg-card shadow-lg rounded-2xl p-4">
        <h2 className="text-lg font-semibold mb-2">Attendance Distribution</h2>
        <ResponsiveContainer height="90%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              outerRadius={100}
              dataKey="value"
              label
            >
              {data.map((_, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </div>

      {/* Bar Chart */}
      <div className="h-[26rem] bg-white shadow rounded-2xl p-4">
        <h2 className="text-lg font-semibold mb-2">Attendance Comparison</h2>
        <ResponsiveContainer height="90%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Legend />
            <Bar dataKey="value" fill="#8884d8" radius={[8, 8, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default AttendanceChart;
